<template>
    <nav class="mobile-tabbar" aria-label="Основная навигация">
        <Link
            href="/"
            class="mobile-tabbar__item"
            :class="{ 'is-active': isActive('/') }"
        >
            <svg class="mobile-tabbar__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/>
            </svg>
            <span class="mobile-tabbar__label">Главная</span>
        </Link>

        <Link
            href="/results"
            class="mobile-tabbar__item"
            :class="{ 'is-active': isActive('/results') }"
        >
            <svg class="mobile-tabbar__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 4h14v16H5V4z" stroke="currentColor" stroke-width="1.75"/>
                <path d="M8 8h8M8 12h8M8 16h5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
            </svg>
            <span class="mobile-tabbar__label">Результаты</span>
        </Link>

        <Link
            href="/teams"
            class="mobile-tabbar__item"
            :class="{ 'is-active': isActive('/teams') }"
        >
            <svg class="mobile-tabbar__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="9" cy="8" r="2.5" stroke="currentColor" stroke-width="1.75"/>
                <circle cx="15" cy="8" r="2.5" stroke="currentColor" stroke-width="1.75"/>
                <path d="M4.5 18c.8-2.4 2.8-3.5 4.5-3.5S12.7 15.6 13.5 18M10.5 18c.8-2.4 2.8-3.5 4.5-3.5s3.7 1.1 4.5 3.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
            </svg>
            <span class="mobile-tabbar__label">Команды</span>
        </Link>

        <button
            type="button"
            class="mobile-tabbar__item"
            :class="{ 'is-active': moreOpen || isMoreSection }"
            :aria-expanded="moreOpen ? 'true' : 'false'"
            aria-controls="mobile-more-sheet"
            @click="$emit('toggle-more')"
        >
            <svg class="mobile-tabbar__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="6" cy="12" r="1.75" fill="currentColor"/>
                <circle cx="12" cy="12" r="1.75" fill="currentColor"/>
                <circle cx="18" cy="12" r="1.75" fill="currentColor"/>
            </svg>
            <span class="mobile-tabbar__label">Ещё</span>
        </button>
    </nav>
</template>

<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

defineProps({
    moreOpen: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['toggle-more']);

const page = usePage();
const currentPath = computed(() => page.url.split('?')[0]);

const isActive = (path) => {
    if (path === '/') {
        return currentPath.value === '/';
    }
    return currentPath.value.startsWith(path);
};

const morePaths = ['/players', '/coaches', '/referees', '/stats', '/profile', '/login', '/admin', '/player'];

const isMoreSection = computed(() =>
    morePaths.some((p) => currentPath.value === p || currentPath.value.startsWith(p + '/') || (p !== '/' && currentPath.value.startsWith(p)))
);
</script>
